import { Outlet, useLocation } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Currency from 'components/Currency';
import { RootStyle, MainStyle } from 'theme/layouts';
import { Box, Typography, useTheme } from '@mui/material';
import { CustomAppBar } from 'theme/layouts/navbar';
import { NavigationBack } from 'theme/elements/Headers';
import { pagesEnum } from 'constants/ui.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import _ from 'lodash';

export default function MobileLayout(props: { noCurrency?: boolean }) {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const location = useLocation();
	const path = location.pathname.replace(/\/\d+$/, '');
	const beneficiaryUrl = `/${pagesEnum.BENEFICIARY}/`;
	const getTitle = () => {
		switch (path) {
			case beneficiaryUrl + 'edit':
				return 'page.beneficiary.edit.header.title';
			case beneficiaryUrl + 'new':
				return 'page.beneficiary.create.header.title';
			case beneficiaryUrl + 'details':
				return 'page.beneficiary.profile.header.title';
			case `/${pagesEnum.BALANCE}`:
				return 'page.balance.view.menu.add';
			case `/${pagesEnum.PAY}/new`:
				return 'page.pay.create.header.title';
			case `/${pagesEnum.CONVERT}/new`:
				return 'page.convert.create.header.title';
		}
		return 'null';
	};

	return (
		<RootStyle>
			<CssBaseline />
			<MainStyle>
				{!props.noCurrency && <Currency />}
				<Outlet />
			</MainStyle>
		</RootStyle>
	);
}
